/**
 * Iconos de la ruleta, dibujados a mano en SVG.
 *
 * Reemplazan a los emojis: los emoji los dibuja el sistema operativo, así que cambian de forma
 * entre Mac, Windows y Android, no se pueden pintar con la paleta del juego y en la rueda se ven
 * como stickers pegados. Estos son paths en un viewBox de 24x24, se escalan sin perder nitidez y
 * heredan los colores.
 */

export const ICONOS = {
    // Sobre dorado con brillo
    sobre: (
        <g>
            <rect x="2" y="5.5" width="20" height="14" rx="2" fill="#ffd166" stroke="#8a6a1f" strokeWidth="1.2" />
            <path d="M2.6 6.4 12 13.2l9.4-6.8" fill="none" stroke="#8a6a1f" strokeWidth="1.4" strokeLinecap="round" />
            <path d="M19 3.2l.7 1.7 1.7.7-1.7.7-.7 1.7-.7-1.7-1.7-.7 1.7-.7z" fill="#fff8e1" />
        </g>
    ),
    // Calavera
    calavera: (
        <g fill="#f1f5f9">
            <path d="M12 2.4c-4.7 0-8 3.2-8 7.5 0 2.5 1.1 4.2 2.6 5.3v2.6c0 .9.7 1.6 1.6 1.6h7.6c.9 0 1.6-.7 1.6-1.6v-2.6c1.5-1.1 2.6-2.8 2.6-5.3 0-4.3-3.3-7.5-8-7.5z" />
            <circle cx="8.8" cy="10" r="2.3" fill="#0a0f1a" />
            <circle cx="15.2" cy="10" r="2.3" fill="#0a0f1a" />
            <path d="M12 13.2l-1.1 2.2h2.2z" fill="#0a0f1a" />
            <rect x="9" y="17.4" width="1.5" height="3" rx="0.6" fill="#f1f5f9" />
            <rect x="11.3" y="17.4" width="1.5" height="3" rx="0.6" fill="#f1f5f9" />
            <rect x="13.6" y="17.4" width="1.5" height="3" rx="0.6" fill="#f1f5f9" />
        </g>
    ),
    // Doble flecha hacia arriba
    subeJugador: (
        <g fill="none" stroke="#86efac" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 12.5l6-6 6 6" />
            <path d="M6 19l6-6 6 6" />
        </g>
    ),
    // Doble flecha hacia abajo
    bajaJugador: (
        <g fill="none" stroke="#fca5a5" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 11.5l6 6 6-6" />
            <path d="M6 5l6 6 6-6" />
        </g>
    ),
    // Avance rápido
    apurado: (
        <g fill="#fca5a5">
            <path d="M3 5.5v13l9-6.5z" />
            <path d="M12 5.5v13l9-6.5z" />
        </g>
    ),
    // Moneda con flecha para arriba
    mercadoCaro: (
        <g>
            <circle cx="10" cy="14" r="6.6" fill="#ffd166" stroke="#8a6a1f" strokeWidth="1.2" />
            <path d="M10 10.6v6.8M7.8 12.6h4.4" stroke="#8a6a1f" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M18 10V3.6M15.4 6.2L18 3.4l2.6 2.8" fill="none" stroke="#86efac" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    ),
    // Moneda con flecha para abajo
    mercadoBarato: (
        <g>
            <circle cx="10" cy="10" r="6.6" fill="#94a3b8" stroke="#475569" strokeWidth="1.2" />
            <path d="M10 6.6v6.8M7.8 8.6h4.4" stroke="#475569" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M18 14v6.4M15.4 17.8l2.6 2.8 2.6-2.8" fill="none" stroke="#fca5a5" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    ),
    // Dos cartas: una dada vuelta y otra mostrando su valor
    apuesta: (
        <g>
            <rect x="3" y="6" width="11" height="15" rx="1.8" transform="rotate(-11 8.5 13.5)"
                fill="#1e293b" stroke="#fbbf24" strokeWidth="1.3" />
            <path d="M6.4 10.6h4.2M6.4 13h4.2M6.4 15.4h2.6" stroke="#fbbf24" strokeWidth="1.1" strokeLinecap="round"
                transform="rotate(-11 8.5 13.5)" />
            <rect x="11" y="4" width="11" height="15" rx="1.8" transform="rotate(9 16.5 11.5)"
                fill="#fde68a" stroke="#b45309" strokeWidth="1.3" />
            <path d="M14 9.4l2.4 4.6 2.4-4.6z" fill="#b45309" transform="rotate(9 16.5 11.5)" />
        </g>
    ),
    // Globo terráqueo
    globo: (
        <g fill="none" stroke="#93c5fd" strokeWidth="1.8">
            <circle cx="12" cy="12" r="9" />
            <ellipse cx="12" cy="12" rx="4" ry="9" />
            <path d="M3.3 9.2h17.4M3.3 14.8h17.4" strokeLinecap="round" />
        </g>
    ),
    // Pin de posición
    pin: (
        <g>
            <path d="M12 2.4c-3.6 0-6.5 2.9-6.5 6.5 0 4.6 6.5 12.4 6.5 12.4s6.5-7.8 6.5-12.4c0-3.6-2.9-6.5-6.5-6.5z"
                fill="#d8b4fe" stroke="#6b21a8" strokeWidth="1.2" />
            <circle cx="12" cy="9" r="2.6" fill="#2e1065" />
        </g>
    ),
    // Escudo
    escudo: (
        <g>
            <path d="M12 2.2l8 3v6.3c0 4.9-3.4 9.3-8 10.4-4.6-1.1-8-5.5-8-10.4V5.2z"
                fill="#86efac" stroke="#166534" strokeWidth="1.3" />
            <path d="M12 6.6l1.5 3.2 3.4.4-2.5 2.3.7 3.4-3.1-1.7-3.1 1.7.7-3.4-2.5-2.3 3.4-.4z" fill="#14532d" />
        </g>
    ),
};

/** Dibuja un icono centrado en (cx, cy) con el tamaño pedido. */
export function Icono({ nombre, cx, cy, size = 34, rotacion = 0 }) {
    const g = ICONOS[nombre];
    if (!g) return null;
    const escala = size / 24;
    return (
        <g transform={`translate(${cx} ${cy}) rotate(${rotacion}) scale(${escala}) translate(-12 -12)`}>
            {g}
        </g>
    );
}
